"use client";

import Image from "next/image";
import { ASSET_PREFIX } from "@/config";
import { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import Link from "next/link";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { usePathname } from "next/navigation";
import path from "path";

gsap.registerPlugin(ScrollTrigger);

const blogData = [
  // {
  //   img: `/images/blogs/why-we-believe-homes-should-work-harder-for-you-not-the-other-way-around-how-pluswilla-makes-it-happen.webp`,
  //   title: "Why We Believe Homes Should Work Harder for You - Not the Other Way Around: How +Willa makes it happen",
  //   date: "07 Jan 2026",
  //   link: "/why-we-believe-homes-should-work-harder-for-you-not-the-other-way-around-how-pluswilla-makes-it-happen/",
  // },
  // {
  //   img: `/images/blogs/the-real-timeline-of-setting-up-a-villa.webp`,
  //   title: "The Real Timeline of Setting Up a Villa (And Why Most Homes Aren’t Ready When You Get the Keys)",
  //   date: "18 Dec 2025",
  //   link: "/the-real-timeline-of-setting-up-a-villa/",
  // },
  // {
  //   img: `/images/blogs/beautiful-ways-to-use-your-pluswilla-sky-garden.webp`,
  //   title: "21 Beautiful Ways to Use Your +Willa Sky Garden",
  //   date: "11 Dec 2025",
  //   link: "/beautiful-ways-to-use-your-pluswilla-sky-garden/",
  // },
  // {
  //   img: "/images/blogs/terrace-garden-safe.webp",
  //   date: "11 Dec 2025",
  //   title: "The Science Behind +Willa’s Sky Garden",
  //   link: "/the-science-behind-plus-willas-sky-garden",
  // },
  // {
  //   img: `/images/blogs/why-pluswilla-banner.webp`,
  //   title:
  //     "Why +Willa Has Built-In Solar Power: Save Your EB Bill for 25 Years & Earn ₹24.6 Lakhs in Return",
  //   date: "22 Nov 2025",
  //   link: "/why-pluswilla-has-built-in-solar-power",
  // },
  {
    img: "/images/blogs/unitd-living-space-signs-128-crore-mou-for-a-new-it-project-in-saravanampatti.webp",
    date: "27 Aug 2026",
    title: "UNITD Living Space Signs ₹128 Crore MoU for a New IT Project in Saravanampatti - What It Means for MUH",
    link: "/unitd-living-space-signs-128-crore-mou-for-a-new-it-project-in-saravanampatti",
    desc: "",
  },
  {
    img: "/images/blogs/tvs-nagar-is-next-to-bloom-as-a-new-residential-hub-for-coimbatore.webp",
    date: "4 Nov 2025",
    title: "TVS Nagar is next to bloom as a new residential hub for Coimbatore",
    link: "/tvs-nagar-is-next-to-bloom-as-a-new-residential-hub-for-coimbatore",
    desc: "",
  },
  {
    img: "/images/blogs/5-reasons-tvs-nagar-is-emerging-as-a-growth-hub-in-coimbatore.webp",
    date: "3 Nov 2025",
    title: "5 Reasons TVS Nagar is Emerging as a Growth Hub in Coimbatore",
    link: "/5-reasons-tvs-nagar-is-emerging-as-a-growth-hub-in-coimbatore",
    desc: "",
  },
  {
    img: "/images/blogs/top-reasons-to-invest-in-villas-plots-in-tvs-nagar.webp",
    date: "2 Nov 2025",
    title: "Top Reasons to Invest in Villas & Plots in TVS Nagar",
    link: "/top-reasons-to-invest-in-villas-plots-in-tvs-nagar",
    desc: "",
  },
  // {
  //   img: "/images/blogs/market-shopping-places-near-tvs-nagar.webp",
  //   date: "1 Nov 2025",
  //   title: "Markets & Shopping Places near TVS Nagar",
  //   link: "/market-shopping-places-near-tvs-nagar",
  //   desc: "",
  // },
];

export default function BlogListing() {
  const pathname = usePathname();

  return (
    <section className="w-[85%] max-w-[110rem] mx-auto blogs-section">
      {/* Heading */}
      <div className="flex justify-between  mb-[0 ] flex-wrap gap-[20px] ">
        <h2
          className="text-[28px]/[36px] md:text-[32px]/[40px] lg:text-[36px]/[44px] xl:text-[40px]/[48px] 2xl:text-[48px]/[54px] text-[#000] font-[600] mb-[20px] sm:mb-[30px]">
          Blogs
        </h2>
      </div>

      {/* Static Grid for ≥2xl */}
      <div className=" grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4  gap-[25px]">
        {(pathname !== "/blog/" && pathname !== "/blog"
          ? blogData.slice(0, 4)
          : blogData
        ).map((item, i) => (
          <div
            key={i}
            className="blog-card group px-[20px] py-[15px] transition duration-300 ease-in-out relative hover:bg-[#f5f5f5] transition duration-300 ease-in-out">
            <div className="overflow-hidden flex">
              <Image
                src={`${ASSET_PREFIX}${item.img}`}
                alt={item.title}
                className="w-full h-auto object-cover object-center group-hover:scale-[1.05] transition duration-300 ease-in-out"
                width={400}
                height={250}
                unoptimized
              />
            </div>

            <div>
              <p className="mb-[10px] mt-[25px] tracking-[-0.03em] text-[#000]">
                {item.date}
              </p>
              <h3 className="text-[18px] leading-[26px] mt-[18px] font-[500] mb-[15px] tracking-[-0.03em] text-[#000] group-hover:text-[#8e722d] transition duration-300 ease-in-out">
                {item.title}
              </h3>
              {/* <p className="mb-[25px]">{item.desc}</p> */}
              <div className="mt-[35px]">
                <Link href={item.link}>View More</Link>
              </div>
            </div>
            {/* Full-card clickable overlay */}
            <Link href={item.link} className="inset-0 absolute" aria-label={item.link}></Link>
          </div>
        ))}
      </div>
    </section>
  );
}
